import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=33a522b3&scoped=true"
import script from "./FormBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./FormBuilder.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormBuilder.vue?vue&type=style&index=0&id=33a522b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a522b3",
  null
  
)

export default component.exports